module.exports = __webpack_public_path__ + "img/jiaoyan2.a1a97fb2.png";